'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // ---------- Sticky nav ----------
  const nav = document.querySelector('#nav');
  const toggleStickyClass = () => {
    nav.classList.toggle('sticky', window.scrollY > 0);
  };
  window.addEventListener('scroll', toggleStickyClass);

  // ---------- Mobile nav ----------
  const mobileNavButton = document.querySelector('#nav-mobile-btn');
  const mobileIcons = document.querySelectorAll('.icon-mobile');
  const mobileNav = document.querySelector('.page-header__nav__mobile');

  function showMobileNav() {
    mobileNav.classList.toggle('nav-open');
    mobileIcons.forEach(icon => icon.classList.toggle('active'));
  }
  mobileNavButton.addEventListener('click', showMobileNav);

  // ------------- Scroll to Top -------------
  const scrollToTopBtn = document.querySelector('.scroll-to-top');
  const headerSection = document.querySelector('.page-header')

  function scrollTop (){
    if(window.scrollY > headerSection.offsetHeight){
      scrollToTopBtn.style.display = 'block';
    }else{
      scrollToTopBtn.style.display = 'none';
    }
    
  }
  window.addEventListener('scroll', scrollTop);

  // ---------- Dynamic image sources ----------
  const compareImages = document.querySelectorAll('.compare__image');
  const updateImages = () => {
    const windowWidth = window.innerWidth;
    compareImages.forEach(img => {
      const smallSrc = img.getAttribute('data-small');
      const largeSrc = img.getAttribute('data-large');
      img.setAttribute('src', windowWidth <= 400 ? smallSrc : largeSrc);
    });
  };
  updateImages();
  window.addEventListener('resize', updateImages);

  //------------ Get footer Year -------------
  function getFooterYear(){
    const year = new Date().getFullYear();
    document.querySelector('.page-footer__year').innerHTML = year;
  }
  getFooterYear();
});